import { useState } from 'react';
import Container from '../../common/Container/Container';
import ServiceIcon from '../../common/ServiceIcon/ServiceIcon';
import styles from './Process.module.css';

const SERVICES = [
  {
    type: 'design',
    title: 'Website & UX/UI Design',
    steps: [
      { title: 'Research',    desc: 'Understand your users and goals' },
      { title: 'Wireframes',  desc: 'Sketch the structure and flow' },
      { title: 'Design',      desc: 'Create the visual interface' },
      { title: 'Prototype',   desc: 'Build interactive mockups' },
      { title: 'Testing',     desc: 'Validate with real users' },
      { title: 'Launch',      desc: 'Go live and iterate' },
    ],
  },
  {
    type: 'web',
    title: 'Custom Web Applications',
    steps: [
      { title: 'Discovery',    desc: 'Define your goals and requirements' },
      { title: 'Design',       desc: 'Wireframes and prototypes' },
      { title: 'Development',  desc: 'Build your application' },
      { title: 'Testing',      desc: 'Quality and performance checks' },
      { title: 'Launch',       desc: 'Deploy to production' },
      { title: 'Support',      desc: 'Ongoing maintenance and updates' },
    ],
  },
  {
    type: 'mobile',
    title: 'Mobile Apps',
    steps: [
      { title: 'Strategy',     desc: 'Define features and audience' },
      { title: 'Design',       desc: 'Create the user interface' },
      { title: 'Development',  desc: 'Build the app' },
      { title: 'Testing',      desc: 'Quality assurance' },
      { title: 'Launch',       desc: 'Publish to app stores' },
      { title: 'Support',      desc: 'Updates and improvements' },
    ],
  },
  {
    type: 'automation',
    title: 'Business Automation',
    steps: [
      { title: 'Analysis',        desc: 'Identify automation opportunities' },
      { title: 'Planning',        desc: 'Map workflows and set goals' },
      { title: 'Solution Design', desc: 'Choose the right tools' },
      { title: 'Implementation',  desc: 'Build and deploy the solution' },
      { title: 'Training',        desc: 'Onboard your team' },
      { title: 'Optimisation',    desc: 'Monitor, refine and improve' },
    ],
  },
];

const Process = () => {
  const [active, setActive] = useState(0);
  const service = SERVICES[active];

  return (
    <section id="process" className={styles.section}>
      <div className="section-label">Our Process</div>

      <Container>
        <div className={styles.intro}>
          <h2 className={styles.heading}>How we work</h2>
          <p className={styles.sub}>
            A clear, collaborative process from first conversation to final delivery.
          </p>
        </div>

        {/* Tab Bar */}
        <div className={styles.tabBar}>
          {SERVICES.map((s, i) => (
            <button
              key={i}
              className={`${styles.tab} ${i === active ? styles.tabActive : ''}`}
              onClick={() => setActive(i)}
            >
              <span className={styles.tabIcon}>
                <ServiceIcon type={s.type} />
              </span>
              <span className={styles.tabLabel}>{s.title}</span>
            </button>
          ))}
        </div>

        {/* Step Flow */}
        <div className={styles.stepsFlow}>
          {service.steps.map((step, i) => (
            <div key={`${active}-${i}`} className={styles.step}>
              <div className={styles.stepTop}>
                <div className={styles.stepCircle}>
                  {String(i + 1).padStart(2, '0')}
                </div>
              </div>
              <div className={styles.stepBody}>
                <h4 className={styles.stepTitle}>{step.title}</h4>
                <p className={styles.stepDesc}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Process;
